import { render, staticRenderFns } from "./ClassicMatterDimensionRow.vue?vue&type=template&id=1d619bec&scoped=true&"
import script from "./ClassicMatterDimensionRow.vue?vue&type=script&lang=js&"
export * from "./ClassicMatterDimensionRow.vue?vue&type=script&lang=js&"
import style0 from "./ClassicMatterDimensionRow.vue?vue&type=style&index=0&id=1d619bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d619bec",
  null
  
)

export default component.exports